// extracted by mini-css-extract-plugin
module.exports = {"Title":"Focus__Title_2EW7h","Wrapper":"Focus__Wrapper_16tNl"};